import { redirect, type RouteObject } from 'react-router';
import { RootLayout } from '@/app/layouts';
import { ROUTES } from '@/shared/routing';
import { RouteError, RouteFallback } from '@/shared/ui';
import type { NavigationGuards } from './navigation.guard';
import {
  createAgreementRoute,
  createAppRoute,
  createAuthRoute,
  createErrorRoute,
  createHelpRoute,
  createOpenRoute,
  createPermissionRoute,
  createSubscriptionRoute,
  createUpdateRequiredRoute,
} from './routes';

/**
 * 라우트 트리를 만든다 (호출처: `composition.ts`). RootLayout 아래에
 * auth · permission · subscription · app · error 노드와 마지막 `*`(NotFound)를 배치한다.
 */
export function createRouteTree(guards: NavigationGuards): RouteObject[] {
  return [
    {
      Component: RootLayout,
      HydrateFallback: RouteFallback,
      ErrorBoundary: RouteError,
      // subscription·help 는 web 전용이라 모바일 빌드에선 null → filter 로 걸러낸다.
      children: [
        createAuthRoute(guards),
        createUpdateRequiredRoute(),
        createPermissionRoute(guards),
        createSubscriptionRoute(guards),
        createAgreementRoute(),
        createHelpRoute(),
        createOpenRoute(),
        createAppRoute(guards),
        createErrorRoute(),
        // 글로벌 폴백 — 매칭 안 되는 경로는 /error(NotFound 화면)로 리다이렉트.
        // splat 은 leaf 의 `path: '*'` 에 둔다(index child 는 splat 아래서 매칭 안 됨).
        // loader 가 redirect 하므로 Component 없음.
        { path: '*', loader: () => redirect(ROUTES.ERROR) },
      ].filter((route) => route !== null),
    },
  ];
}
